import React from "react";
import { useTranslation } from "react-i18next";
import { X } from "@phosphor-icons/react";

/**
 * v0.4.33 — Selected ingest-runs chips banner, extracted from
 * CalculatePanel to keep the parent under the 400-LOC project cap.
 *
 * Each chip is one selected ingest run with click-to-remove. The
 * chip's colour distinguishes production (emerald) from test
 * fixtures (red).
 */
export const SelectedRunsBanner = ({ selectedRuns, isFixture, onToggle }) => {
  const { t } = useTranslation();
  if (!selectedRuns || selectedRuns.length === 0) return null;
  const totalRows = selectedRuns
    .reduce((s, r) => s + (r.rows_accepted || 0), 0)
    .toLocaleString();
  return (
    <div
      data-testid="selected-runs-banner"
      className="border-t border-slate-200 dark:border-slate-700 px-4 py-3 bg-teal-50 dark:bg-teal-900/40"
    >
      <div className="text-[10px] tracking-normal text-teal-700 dark:text-teal-300 tabular-nums mb-2">
        {t("ui.calculate.selected_runs_chip", {
          count: selectedRuns.length,
          rows: totalRows,
        })}
      </div>
      <div className="flex flex-wrap gap-2">
        {selectedRuns.map((r) => (
          <span
            key={r.id}
            data-testid={`selected-chip-${r.id}`}
            className={`tabular-nums text-[11px] px-2 py-1 border ${
              isFixture(r)
                ? "border-red-500/40 dark:border-red-800 text-red-700 dark:text-red-300 bg-red-500/5"
                : "border-emerald-500/40 dark:border-emerald-700 text-emerald-700 dark:text-emerald-300 bg-emerald-600/5"
            } flex items-center gap-1`}
          >
            {isFixture(r)
              ? t("ui.calculate.fixture_chip")
              : t("ui.calculate.prod_chip")} · {r.filename} · {r.rows_accepted}{" "}
            {t("ui.calculate.rows_suffix")}
            <button
              type="button"
              onClick={() => onToggle(r.id)}
              data-testid={`selected-chip-remove-${r.id}`}
              className="ml-1 hover:opacity-70"
            >
              <X size={10} weight="bold" />
            </button>
          </span>
        ))}
      </div>
    </div>
  );
};
